"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.WkCarousel = void 0;
require("./carousel.scss");
var gsap_1 = require("gsap");
var Draggable_1 = require("gsap/Draggable");
var lodash_1 = require("lodash");
var Component_1 = require("../Component");
var util_1 = require("../util");
gsap_1.gsap.registerPlugin(Draggable_1.Draggable);
var WkCarousel = /** @class */ (function (_super) {
    __extends(WkCarousel, _super);
    function WkCarousel(options) {
        var _this = _super.call(this, (options === null || options === void 0 ? void 0 : options.element) || util_1.htmlDiv()) || this;
        _this.slideDuration = 0.45;
        _this.slideMeth = gsap_1.Power2.easeInOut;
        _this.dots = (options === null || options === void 0 ? void 0 : options.dots) === false ? false : true;
        _this.arrows = (options === null || options === void 0 ? void 0 : options.arrows) === false ? false : true;
        return _this;
    }
    WkCarousel.prototype.onInit = function () {
        var _this = this;
        var $el = this.$element;
        $el.addClass('wk-carousel');
        if (!this.resizeListener) {
            this.resizeListener = function () { _this.initLayout(); };
            window.addEventListener('resize', this.resizeListener);
        }
        this.$inner = util_1.$div('carousel-inner');
        this.$navDots = util_1.$div('nav-dots');
        $el.empty().append(this.$inner, this.$navDots);
        if (this.arrows) {
            this.$element.append(util_1.$div('nav-arrow nav-arrow-next')
                .append(util_1.$svg('svg', { viewBox: "0 0 320 512" })
                .append(util_1.$svg('path', { fill: "currentColor", d: "M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z" })))
                .on('click', function () { return _this.navigateSlideNext(); }), util_1.$div('nav-arrow nav-arrow-prev')
                .append(util_1.$svg('svg', { viewBox: "0 0 320 512" })
                .append(util_1.$svg('path', { fill: "currentColor", d: "M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z" })))
                .on('click', function () { return _this.navigateSlidePrev(); }));
        }
    };
    WkCarousel.prototype.initCarousel = function (initialIndex) {
        this.activeIndex = initialIndex;
        this.initLayout();
        this.setupDraggable();
    };
    WkCarousel.prototype.onDestroy = function () {
        if (this.resizeListener) {
            window.removeEventListener('resize', this.resizeListener);
        }
    };
    WkCarousel.prototype.initLayout = function () {
        var _this = this;
        var $el = this.$element;
        this.itemCount = $el.findAll('.carousel-item').length;
        this.itemWidth = $el.element.offsetWidth;
        this.$inner.element.style.width = (this.itemWidth * this.itemCount) + 'px';
        this.$element.findAll('.carousel-item').forEach(function (item) {
            item.style.width = _this.itemWidth + 'px';
        });
        var xTarget = this.activeIndex * this.itemWidth * -1;
        gsap_1.TweenMax.to(this.$inner.element, { x: xTarget });
        this.initDots();
        this.navigateSlide(this.activeIndex, false);
    };
    WkCarousel.prototype.setupDraggable = function () {
        var _this = this;
        var $el = this.$element;
        var swipeDir;
        Draggable_1.Draggable.create(this.$inner.element, {
            type: 'x',
            edgeResistance: 0.9,
            dragResistance: 0.0,
            bounds: this.element,
            onDrag: function () {
                swipeDir = this.getDirection('start');
            },
            onThrowUpdate: function () {
                swipeDir = this.getDirection('start');
            },
            throwProps: true,
            onDragStart: function (evt) { },
            onDragEnd: function () {
                if (swipeDir === 'left') {
                    _this.navigateSlideNext();
                }
                else if (swipeDir === 'right') {
                    _this.navigateSlidePrev();
                }
            },
        });
    };
    // set up dots
    WkCarousel.prototype.initDots = function () {
        var _this = this;
        var $navDots = this.$navDots.empty();
        if (this.dots && this.itemCount > 1) {
            lodash_1.range(0, this.itemCount).forEach(function (index) {
                $navDots.append(util_1.$div('nav-dot').on('click', function () { return _this.onNavigateSlide(index); }));
            });
        }
    };
    WkCarousel.prototype.navigateSlideNext = function () {
        this.onNavigateSlide(this.activeIndex + 1);
    };
    WkCarousel.prototype.navigateSlidePrev = function () {
        this.onNavigateSlide(this.activeIndex - 1);
    };
    WkCarousel.prototype.onNavigateSlide = function (targetIndex) {
        var oldIndex = this.activeIndex;
        var resultIndex = this.navigateSlide(targetIndex);
        if (oldIndex !== resultIndex) {
            this.element.dispatchEvent(new CustomEvent('carousel-navigate', {
                detail: { targetIndex: resultIndex }
            }));
        }
    };
    WkCarousel.prototype.getCurrentIndex = function () {
        return this.activeIndex;
    };
    // navigate slide
    WkCarousel.prototype.navigateSlide = function (targetIndex, animation) {
        if (targetIndex >= this.itemCount - 1)
            targetIndex = this.itemCount - 1;
        if (targetIndex <= 0)
            targetIndex = 0;
        var xTarget = targetIndex * this.itemWidth * -1;
        var duration = (animation === false ? 0 : this.slideDuration);
        gsap_1.TweenMax.to(this.$inner.element, duration, { x: xTarget, ease: this.slideMeth });
        this.$navDots.findAll('.nav-dot').forEach(function (dot, i) { return util_1.toggleClass(dot, 'active', i === targetIndex); });
        var navPrev = this.$element.findFirst('.nav-arrow.nav-arrow-prev');
        if (navPrev)
            navPrev.style.display = (targetIndex === 0 ? 'none' : 'block');
        var navNext = this.$element.findFirst('.nav-arrow.nav-arrow-next');
        if (navNext)
            navNext.style.display = (targetIndex + 1 === this.itemCount ? 'none' : 'block');
        this.activeIndex = targetIndex;
        return targetIndex;
    };
    WkCarousel.prototype.updateItems = function (items, initialIndex) {
        this.$inner.empty();
        for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
            var item = items_1[_i];
            if (util_1.hasClass(item, 'carousel-item')) {
                this.$inner.append(item);
            }
            else {
                this.$inner.append(util_1.$div('carousel-item').append(item));
            }
        }
        this.initCarousel(initialIndex || 0);
    };
    return WkCarousel;
}(Component_1.Component));
exports.WkCarousel = WkCarousel;
